/* The label behind an icon-only control. The surface is `MenuSurface`'s `.popup`, worn as a doubled
 * class the way `HintPopover` wears it — two single-class selectors in two CSS Modules are settled
 * by chunk order, which differs between the dev server and the build. */

/* On the POSITIONER, not on the popup: Base UI positions through inline styles there and the popup
 * inside is `position: static`. 40 is this app's popover layer. */
.positioner {
  z-index: 40;
}

.popup.popup {
  --w-tooltip: 260px;

  min-width: var(--space-0);
  max-width: var(--w-tooltip);
  padding: var(--space-5px) var(--space-9px);
  color: var(--text);
  font-size: var(--fs-label-sm);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-normal);
  white-space: nowrap;
}
